export const environment = {
  softwareVersion: 58,
  production: true,
  isolation: "__",
  itemsTimeoutInSeconds: 3600,
  sessionTimeout: 1113600,
  subscribeDashboardSummaryOrderStatus: false,
  subscribeDashboardCompletedOrders: false,
  isEnableHomePage: true,
  apiDomain: 'api.khmum-pos.com',
  imageDomain: 'static.khmum-pos.com',
  adminEmail: "versita.store.vr.prd@gmail.com",
  adminPassword: "ektjasjusoedyecw",
  encryptKey: "!Zw8q4ZNc)wuZRDz*LC%8BE?Fr>PK_G:", // must be 32 char long
  isPhoneEnable: true,
  isEmailEnable: false,
  firebase: {
    apiKey: "AIzaSyDt3EXkgEVSacBI8IPJ_ruhB0vAOSiEMzw",
    authDomain: "khmum.com",
    databaseURL: "https://versita-store-vr-prd.firebaseio.com",
    projectId: "versita-store-vr-prd",
    storageBucket: "versita-store-vr-prd.appspot.com",
    messagingSenderId: "214015489445",
    appId: '1:214015489445:web:39f95075e450c56f'
  }
};
